import React from 'react'
import AllComp from '../components/AllComp'
import PageHead from './PageHead'
import SingleProp from './SingleProp'
import Best from './Best'
import Footer from './Footer'

function AllDetails() {
  return (
    <div>
      <AllComp/>;
      <PageHead/>;
      <SingleProp/>;
      <Best/>;
      <Footer/>;
    </div>
  )
}

export default AllDetails
